import requests from "./httpService";

const TimeSlotServices = {
   
    getTime: async () => {
        return requests.get(`/time-slot-managment`);
    },
    
   
    createTimeSlots: async (timeRange) => {
        return requests.post(`/time-slot-managment`, timeRange);
    },
    
    
    updateTimeSlot: async (id, timeData) => {
        return requests.put(`/time-slot-managment/${id}`, timeData);
    },
    
    deleteTimeSlots: async () => {
        return requests.delete(`/time-slot-managment`);
    }
};

export default TimeSlotServices;